import React, { FC } from 'react';
import { BackButton } from 'src/common';
import { useTaskNav } from 'src/models/bids/BidTask/hooks';
import { useBidUrl } from 'src/models/procurements/hooks';

export const BackToButton: FC = () => {
  const { data: navData } = useTaskNav();
  const bidUrl = useBidUrl(navData?.bidId ?? '');

  return <BackButton href={bidUrl} />;
};

export default BackToButton;
